import Vue from 'vue'
import store from '../store'

export const Login = function (email, password) {
    var args = {
        address: email,
        password
    }

    return Vue.http.post('Login', args)
        .then((response) => {
            //  errors
            if (response.body.errors) {
                return response.body
            }

            store.commit('accessToken', response.body.token)

            return response.body
        })
}

export const Me = function (shouldSave) {
    return Vue.http.get('me?token=' + store.state.user.access_token)
        .then(response => {
            if (response.body.errors) {
                return false
            }

            if (shouldSave) {
                store.commit('updateUser', response.body)
            }

            return response.body
        })
}

export const ModelRegister = function (info) {
    return Vue.http.post('model/register/', info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const profileAdminRegister = function (info) {
    return Vue.http.post('user/register/', info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const saveBankInfo = function (info, token, id) {
    return Vue.http.post('bank/info/save', info, {
        headers: {
            'Authorization': token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const saveModelPlatform = function (array, token, id) {
    var info = {platforms: array}
    return Vue.http.post('platforms/info/save', info, {
        headers: {
            'Authorization': token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getPlatforms = function (id) {
    return Vue.http.get('platforms/' + id + '/info', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw new Error(response.body.errors)
            }
            return response.body
        })
}

export const getProfileInfo = function (id) {
    return Vue.http.get('profile/' + id + '/info', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw new Error(response.body.errors)
            }
            return response.body
        })
}

export const getAdminProfileInfo = function (id) {
    return Vue.http.get('profile/' + id + '/info/admin', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw new Error(response.body.errors)
            }
            return response.body
        })
}

export const getBankInfo = function (id) {
    return Vue.http.get('bank/' + id + '/info', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw new Error(response.body.errors)
            }
            return response.body
        })
}

export const updatePlatform = function (info) {
    return Vue.http.post('platforms/info/update', info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const updateBankInfo = function (info) {
    return Vue.http.post('bank/info/update', info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const updateProfileInfo = function (info) {
    return Vue.http.post('profile/info/update', info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const updateAdminProfileInfo = function (info) {
    return Vue.http.post('profile/info/admin/update', info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const changeStatus = function (status, id) {
    var info = {
        status: status,
        id: id
    }
    return Vue.http.post('change/status', info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const changeStatusAdmin = function(id, status) {
    var info = {
        status: status,
        id: id
    }
    return Vue.http.post('change/status/admin', info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response) {
                throw response.body.error
            }

            return response.body
        })
}

export const addNewPlatforms = function (info) {
    return Vue.http.post('platforms/new/info/save', info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const deletePlatform = function(uid, id) {
    return Vue.http.delete('platforms/delete/user/' + uid + '/platform/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getApprovedList = function(limit, offset) {
    return Vue.http.get(`models/approved?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getBlockList = function(limit, offset) {
    return Vue.http.get(`models/blocked?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getNewList = function(limit, offset) {
    return Vue.http.get(`models/news?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getPendingList = function(limit, offset) {
    return Vue.http.get(`models/pending?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getAllModels = function(limit, offset, search) {
    var route
    if (search) {
        route = `models/all?search=${search}&limit=${limit}&offset=${offset}`
    } else {
        route = `models/all?limit=${limit}&offset=${offset}`
    }
    return Vue.http.get(route, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const createCategory = function (name) {
    return Vue.http.post('create/new/category/', {name: name}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getCategories = function () {
    return Vue.http.get('categories/list', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const deleteCategory = function(id) {
    return Vue.http.delete('remove/category/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getCategory = function (id) {
    return Vue.http.get('category/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const changeName = function (id, name) {
    return Vue.http.post('change/name/category/' + id, {name: name}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const addProduct = function (id, info) {
    return Vue.http.post('add/product/category/' + id, info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const deleteProduct = function(name) {
    return Vue.http.delete('delete/product/' + name, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const productUpdatePhoto = function (image, id) {
    var formData = new FormData()
    formData.append('path', image)

    return Vue.http.post('update/product/picture/' + id + '?token=' + store.state.user.access_token, formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }

            return response.body
        })
}

export const exportProfiles = function (options) {
    return Vue.http.post('exports/profiles?token=' + store.state.user.access_token, options)
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }

            return response.body
        })
}

export const importProfiles = function (profiles) {
    var formData = new FormData()
    formData.append('path', profiles)

    return Vue.http.post('add/new/profiles?token=' + store.state.user.access_token, formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }

            return response.body
        })
}

export const importNominaAdmin = function (profiles, nominaId) {
    var formData = new FormData()
    formData.append('path', profiles)

    return Vue.http.post('generate/nomina/' + nominaId + '/admin?token=' + store.state.user.access_token, formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }

            return response.body
        })
}

export const getAllProducts = function (limit, offset = 0, search) {
    var route
    if (search) {
        route = process.env.API_BASE + `products/all?search=${search}&limit=${limit}&offset=${offset}`
    } else {
        route = process.env.API_BASE + `products/all?limit=${limit}&offset=${offset}`
    }
    return Vue.http.get(route, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getInfoProducts = function () {
    return Vue.http.get('products/all/info', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getProductsCategoryList = function (name) {
    return Vue.http.get('category/products/info/' + name, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getProductInfo = function (name) {
    return Vue.http.get('product/info/' + name, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getIngresos = function (name) {
    return Vue.http.get('product/ingresos/' + name, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getSells = function (name) {
    return Vue.http.get('product/sells/' + name, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getCategoryList = function (name) {
    return Vue.http.get('category/list/name', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const changeProductInfo = function (info, id) {
    return Vue.http.post('change/product/info/' + id, info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const addInventory = function (info, name) {
    return Vue.http.patch('add/inventory/' + name, info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const productUpdatePhotoByName = function (image, name) {
    var formData = new FormData()
    formData.append('path', image)

    return Vue.http.post('update/product/picture/name/' + name + '?token=' + store.state.user.access_token, formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }

            return response.body
        })
}

export const deleteInventory = function (info, name) {
    return Vue.http.patch('delete/inventory/' + name, info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getPendingDocuments = function () {
    return Vue.http.get('documents/pending/list', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getApprovedDocuments = function () {
    return Vue.http.get('documents/approved/list', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const generateDocument = function (id, info) {
    return Vue.http.post('create/model/document/' + id, info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getOweStoreByModel = function (id) {
    return Vue.http.get('owe/store/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getOweVariedadesByModel = function (id) {
    return Vue.http.get('owe/variedades/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getOweJugueteriaByModel = function (id) {
    return Vue.http.get('owe/jugueteria/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getAbonoListByModel = function (id) {
    return Vue.http.get('list/abono/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getOweMultasByModel = function (id) {
    return Vue.http.get('owe/multas/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getMultasListByModel = function (id) {
    return Vue.http.get('list/multas/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getAllMultasListByModel = function (id, limit, offset = 0) {
    return Vue.http.get(`all/list/multas/model/${id}?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getStoreListByModel = function (id) {
    return Vue.http.get('list/store/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getPendingChargesByModel = function (id) {
    return Vue.http.get('owe/charges/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getModelStagename = function (id) {
    return Vue.http.get('model/stagename/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const createMultaByModel = function (info) {
    return Vue.http.patch('create/multas/model/', info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const createIngresoByModel = function (info) {
    return Vue.http.patch('create/ingreso/model/', info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const deleteModelMulta = function (id) {
    return Vue.http.delete('delete/multas/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const deleteModelIngreso = function (id) {
    return Vue.http.delete('delete/ingresos/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getBankCertificate = function (id) {
    return Vue.http.get('certificate/bancario/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getSalaryCertificate = function (id) {
    return Vue.http.get('certificate/ingresos/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getPendingDocumentsByModel = function (id) {
    return Vue.http.get('documents/pending/list/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getPendingProductsToDelete = function (id) {
    return Vue.http.get('products/pending/list/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const removeProductLedger = function(id) {
    return Vue.http.delete('remove/product/ledger/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const removeProductSolicitud = function(id) {
    return Vue.http.delete('remove/product/solicitud/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const removeSolicitdPicture = function(id) {
    return Vue.http.delete('remove/picture/solicitud/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const aprobarPicture = function(id) {
    return Vue.http.patch('approve/picture/solicitud/' + id, {}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getNotificationsModel = function (id) {
    return Vue.http.get('notifications/model/list/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const NotificationsTypes = function () {
    return Vue.http.get('notifications/types', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const createIndividualNotice = function (id, info) {
    return Vue.http.post('create/notification/individual/model/' + id, info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const deleteNotificationByModel = function(modelid, notificationid) {
    return Vue.http.delete('remove/notification/' + notificationid + '/model/' + modelid, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const pauseNotificationByModel = function(modelid, notificationid) {
    return Vue.http.post('pause/notification/' + notificationid + '/model/' + modelid, {}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const resetNotificationByModel = function(modelid, notificationid) {
    return Vue.http.post('reset/notification/' + notificationid + '/model/' + modelid, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const changeDateNotificationByModel = function(modelid, notificationid, info) {
    return Vue.http.post('change/date/notification/' + notificationid + '/model/' + modelid, info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getNotificationModelList = function (limit = 'ALL', offset = 0, search) {
    var route
    if (search) {
        route = process.env.API_BASE + `notification/models/list?search=${search}&limit=${limit}&offset=${offset}`
    } else {
        route = process.env.API_BASE + `notification/models/list?limit=${limit}&offset=${offset}`
    }
    return Vue.http.get(route, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const createNotificationGroup = function(info) {
    return Vue.http.post('create/notification', info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getNotifications = function (limit = 'ALL', offset = 0, status) {
    return Vue.http.get(`notifications/list/${status}?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getModelWithOutNofitication = function (notification, limit = 'ALL', offset = 0, search) {
    var route
    if (search) {
        route = process.env.API_BASE + `models/without/notification/${notification}?search=${search}&limit=${limit}&offset=${offset}`
    } else {
        route = process.env.API_BASE + `models/without/notification/${notification}?limit=${limit}&offset=${offset}`
    }
    return Vue.http.get(route, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const addModelsToNotificacion = function(notification, models) {
    return Vue.http.post('add/models/notification/' + notification, models, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const notificationChangeDate = function(notificationid, info) {
    return Vue.http.post('change/date/notification/' + notificationid, info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const pauseNotification = function(notificationid) {
    return Vue.http.post('pause/notification/' + notificationid, {}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const resetNotification = function(notificationid) {
    return Vue.http.post('reset/notification/' + notificationid, {}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const deleteNotification = function(notificationid) {
    return Vue.http.delete('remove/notification/' + notificationid, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getInventory = function (limit = 'ALL', offset = 0) {
    return Vue.http.get(`inventory/list?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getPendingProducts = function (limit = 'ALL', offset = 0) {
    return Vue.http.get(`pending/products/delete/list?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getPendingPictures = function (limit = 'ALL', offset = 0) {
    return Vue.http.get(`pending/pictures/list?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getApprovedProducts = function (limit = 'ALL', offset = 0) {
    return Vue.http.get(`approved/products/delete/list?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getMultasList = function (limit = 'ALL', offset = 0) {
    return Vue.http.get(`multas/list?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getIngresosList = function (limit = 'ALL', offset = 0) {
    return Vue.http.get(`ingresos/list?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getCantMultas = function () {
    return Vue.http.get('multas/cantidad', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getCantIngresos = function () {
    return Vue.http.get('ingresos/cantidad', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getSumMultas = function () {
    return Vue.http.get('multas/total', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getSumIngresos = function () {
    return Vue.http.get('ingresos/total', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getCantMultasHoy = function () {
    return Vue.http.get('multas/cantidad/hoy', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getCantIngresosHoy = function () {
    return Vue.http.get('ingresos/cantidad/hoy', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getSumMultasHoy = function () {
    return Vue.http.get('multas/total/hoy', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getSumIngresosHoy = function () {
    return Vue.http.get('ingresos/total/hoy', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const mostFinedModels = function () {
    return Vue.http.get('models/fined/multas', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const mostFinedModelsIngresos = function () {
    return Vue.http.get('models/fined/ingresos', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getModelsWithStatusNotblock = function (limit, offset) {
    return Vue.http.get(`models/not/block?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getConsumos = function (limit, offset) {
    return Vue.http.get(`consumos?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getBestBuyer = function () {
    return Vue.http.get('best/buyer', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getBestProducts = function () {
    return Vue.http.get('best/products', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getPendings = function (limit, offset) {
    return Vue.http.get(`pendings?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getCantConsumos = function () {
    return Vue.http.get('consumos/cantidad', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getSumConsumos = function () {
    return Vue.http.get('consumos/total', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getCantConsumosHoy = function () {
    return Vue.http.get('consumos/cantidad/hoy', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getSumConsumosHoy = function () {
    return Vue.http.get('consumos/total/hoy', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getUsersTypes = function () {
    return Vue.http.get('users/types', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getModelsListByAdmin = function (id) {
    return Vue.http.get('model/list/admin/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getMonitorList = function () {
    return Vue.http.get('list/monitor', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getAdministradorList = function () {
    return Vue.http.get('list/administrador', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const saveMonitor = function(id, monitorId) {
    return Vue.http.post('save/relation/monitor/model/' + id, {monitor: monitorId}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const saveAdmin = function(id, monitorId) {
    return Vue.http.post('save/relation/admin/model/' + id, {admin: monitorId}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getMonitorAndAdmin = function(id) {
    return Vue.http.get('monitor/admin/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getLedgersModel = function(id) {
    return Vue.http.get('list/ledgers/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getPlatformsModel = function (id) {
    return Vue.http.get('platforms/info/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getPositionByModel = function(id) {
    return Vue.http.get('position/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getTotalModelsByPlatform = function(platform) {
    return Vue.http.get('cant/models/' + platform, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getUsersDetect = function() {
    return Vue.http.get('profiles/platforms/detect', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const deleteUserDetect = function(user) {
    return Vue.http.delete('profiles/platforms/detect/' + user, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const updateUsersDetects = function() {
    return Vue.http.post('profiles/platforms/detect/update', { }, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getTotalDollarsByPlatform = function(platform) {
    return Vue.http.get('dollars/' + platform, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getPlatformsLedgers = function(limit, offset, platform, search) {
    var route
    if (search) {
        route = `platform/ledgers/${platform}?search=${search}&limit=${limit}&offset=${offset}`
    } else {
        route = `platform/ledgers/${platform}?limit=${limit}&offset=${offset}`
    }
    return Vue.http.get(route, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getModelsPlatformRanking = function(platform, orientation) {
    return Vue.http.get(`platform/${platform}/models?orientation=${orientation}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getTotalTokensToday = function(platform) {
    return Vue.http.get(`platform/${platform}/total/today`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getDayPlatformRanking = function(platform, orientation) {
    return Vue.http.get(`platform/${platform}/raking?orientation=${orientation}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getPlatformsStudioTotal = function(platform) {
    return Vue.http.get(`platform/${platform}/studio/total`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getAdminList = function() {
    return Vue.http.get(`admin/list`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getPlatformsStudioCant = function() {
    return Vue.http.get(`studio/cant`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const startStore = function() {
    return Vue.http.patch('start/store', {}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getLastStoreStatus = function() {
    return Vue.http.get(`store/status`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getOpenVentas = function() {
    return Vue.http.get(`open/store/ventas`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const changeCantidadProducto = function(id, cantidad) {
    return Vue.http.patch('store/change/ledger/' + id + '/cantidad', {cantidad: cantidad}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const removeLedgerStore = function(id) {
    return Vue.http.delete('store/delete/ledger/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const closeVenta = function(id, paymode) {
    return Vue.http.patch('store/close/venta/' + id, {paymode: paymode}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getFinalizeVentas = function() {
    return Vue.http.get(`store/finalize/ventas`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const solicitudEliminar = function(ledgers, buyer, details) {
    return Vue.http.patch('store/delete/solicitud', {ledgers: ledgers, buyer_id: buyer, details: details}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const removeVenta = function(id) {
    return Vue.http.delete('store/remove/venta/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const closeStore = function() {
    return Vue.http.post('store/close', {}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const getSedesList = function() {
    return Vue.http.get('sedes/list', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const getHabsBySede = function(sede) {
    return Vue.http.get('habs/' + sede, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const getAdminInfo = function() {
    return Vue.http.get('profile/admin/info', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const changeAdminProfile = function (info) {
    return Vue.http.post('change/admin/profile/info', info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const profileAdminPictureUpdate = function (image, id) {
    var formData = new FormData()
    formData.append('path', image)

    return Vue.http.post('update/profile/admin/picture?token=' + store.state.user.access_token, formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }

            return response.body
        })
}

export const changePasswordAdmin = function (pass) {
    return Vue.http.post('change/password/admin', {pass: pass}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const getAllModelsStore = function(limit = 'ALL', offset = 0, search) {
    var route
    if (search) {
        route = `store/all/models?search=${search}&limit=${limit}&offset=${offset}`
    } else {
        route = `store/all/models?limit=${limit}&offset=${offset}`
    }
    return Vue.http.get(route, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const getCategoriesStore = function () {
    return Vue.http.get('categories/list/store', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getProductsListByCategory = function (name, type) {
    return Vue.http.get('category/products/info/' + name + '/store/' + type, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

const generateSellStore = function(id, products, paymode) {
    return Vue.http.patch('generate/sell/model/' + id + '/store', {products: products, paymode: paymode}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const updateProfilePicture = function (image, id) {
    var formData = new FormData()
    formData.append('path', image)

    return Vue.http.post('update/profile/picture/model/' + id + '?token=' + store.state.user.access_token, formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }

            return response.body
        })
}

export const getAllModelsSearch = function(limit = 'ALL', offset = 0, search) {
    var route
    if (search) {
        route = process.env.API_BASE + `models/all/list?search=${search}&limit=${limit}&offset=${offset}`
    } else {
        route = process.env.API_BASE + `models/all/list?limit=${limit}&offset=${offset}`
    }
    return Vue.http.get(route, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const createPendingCharge = function(id, total, type) {
    return Vue.http.post('create/pending/model/' + id + '/charge', {total: total, type: type}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getEgresosTypeList = function() {
    return Vue.http.get('egresos/type/list', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getIngresosTypeList = function() {
    return Vue.http.get('ingresos/type/list', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const addNewEgresoType = function(name) {
    return Vue.http.post('create/egreso/type', {name: name}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const addNewIngresoType = function(name) {
    return Vue.http.post('create/ingreso/type', {name: name}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const deleteEgresoType = function(id) {
    return Vue.http.delete('remove/egreso/type/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const deleteIngresoType = function(id) {
    return Vue.http.delete('remove/ingreso/type/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getAllModelsToSelect = function(limit = 'ALL', offset = 0, search) {
    var route
    if (search) {
        route = `select/all/models?search=${search}&limit=${limit}&offset=${offset}`
    } else {
        route = `select/all/models?limit=${limit}&offset=${offset}`
    }
    return Vue.http.get(route, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const getAllSolicitudes = function(limit = 'ALL', offset = 0) {
    return Vue.http.get(`all/solicitudes?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const getNominas = function(limit = 'ALL', offset = 0) {
    return Vue.http.get(`all/nominas?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const editarNomina = function(subnonimas, id) {
    return Vue.http.post(`update/subnominas/${id}`, {subnonimas: subnonimas}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const changeProductType = function(name, type) {
    return Vue.http.post(`update/product/type/${name}`, {type: type}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const changeTRM = function(id, trm) {
    return Vue.http.post(`update/trm`, {id: id, TRM: trm}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const getPendingTypes = function() {
    return Vue.http.get('pendings/type/list', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getAnticiposTypes = function() {
    return Vue.http.get('anticipos/type/list', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getAnticiposMedios = function() {
    return Vue.http.get('anticipos/medios/list', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const statusList = function() {
    return Vue.http.get('status/list', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const deletePending = function(id) {
    return Vue.http.delete('remove/pending/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const editEgreso = function(id, valor, type, motivo, flag) {
    return Vue.http.post(`update/egreso/${id}`, {valor: valor, type: type, motivo: motivo, flag: flag}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const editIngreso = function(id, valor, type, motivo, flag) {
    return Vue.http.post(`update/ingreso/${id}`, {valor: valor, type: type, motivo: motivo, flag: flag}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const getPlatformsNomina = function(uid, nid) {
    return Vue.http.get('platforms/nomina/' + nid + '/list/model/' + uid, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getPendingNomina = function(uid, nid) {
    return Vue.http.get('pending/nomina/' + nid + '/list/model/' + uid, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getAnticiposNomina = function(uid, nid) {
    return Vue.http.get('anticipos/nomina/' + nid + '/list/model/' + uid, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getEgresosNomina = function(uid, nid) {
    return Vue.http.get('egresos/nomina/' + nid + '/list/model/' + uid, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getIngresosNomina = function(uid, nid) {
    return Vue.http.get('ingresos/nomina/' + nid + '/list/model/' + uid, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getJugueteriaNomina = function(uid, nid) {
    return Vue.http.get('jugueteria/nomina/' + nid + '/list/model/' + uid, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getVariedadesNomina = function(uid, nid) {
    return Vue.http.get('variedades/nomina/' + nid + '/list/model/' + uid, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getMecatoNomina = function(uid, nid) {
    return Vue.http.get('mecato/nomina/' + nid + '/list/model/' + uid, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getLastLedgersNomina = function(uid, nid) {
    return Vue.http.get('last/platforms/nomina/' + nid + '/list/model/' + uid, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const addPendingNomina = function(uid, nid, info) {
    return Vue.http.post(`pending/nomina/${nid}/user/${uid}`, info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const addEgresoNomina = function(uid, nid, info) {
    return Vue.http.post(`egreso/nomina/${nid}/user/${uid}`, info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const addAnticipoNomina = function(uid, nid, info) {
    return Vue.http.post(`anticipo/nomina/${nid}/user/${uid}`, info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const addIngresoNomina = function(uid, nid, info) {
    return Vue.http.post(`ingreso/nomina/${nid}/user/${uid}`, info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const addVentaNomina = function(uid, nid, products) {
    return Vue.http.patch(`venta/nomina/${nid}/user/${uid}`, {products: products}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const getPlatformsSubnomina = function(uid, nid) {
    return Vue.http.get('platforms/subnomina/' + nid + '/list/model/' + uid, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const detelePendingNomina = function(uid, nid, id) {
    return Vue.http.delete('pending/' + id + '/nomina/' + nid + '/list/model/' + uid, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const deleteEgresoNomina = function(uid, nid, id) {
    return Vue.http.delete('egreso/' + id + '/nomina/' + nid + '/list/model/' + uid, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const deteleAnticipoNomina = function(uid, nid, id) {
    return Vue.http.delete('anticipo/' + id + '/nomina/' + nid + '/list/model/' + uid, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const deleteIngresoNomina = function(uid, nid, id) {
    return Vue.http.delete('ingreso/' + id + '/nomina/' + nid + '/list/model/' + uid, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const deleteVentaNomina = function(uid, nid, id) {
    return Vue.http.delete('venta/' + id + '/nomina/' + nid + '/list/model/' + uid, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const addSkyprivateLedgers = function(ledger, uid) {
    return Vue.http.post(`add/skyprivate/ledger/user/${uid}`, {ledger: ledger}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const detectModels = function (profiles, platform) {
    var formData = new FormData()
    formData.append('path', profiles)

    return Vue.http.post('detect/profiles/platform/' + platform + '?token=' + store.state.user.access_token, formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }

            return response.body
        })
}

export const uploadMultasXML = function (multas) {
    var formData = new FormData()
    formData.append('path', multas)

    return Vue.http.post('upload/multas/xml/?token=' + store.state.user.access_token, formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }

            return response.body
        })
}

export const uploadIngresosXML = function (multas) {
    var formData = new FormData()
    formData.append('path', multas)

    return Vue.http.post('upload/ingresos/xml/?token=' + store.state.user.access_token, formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }

            return response.body
        })
}

export const updateBongaLedgers = function() {
    return Vue.http.post('update/bongacams/ledgers/?token=' + store.state.user.access_token, {})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }

            return response.body
        })
}

export const createNomina = function() {
    return Vue.http.post('create/nomina', {}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response) {
                throw response.body.error
            }

            return response.body
        })
}

export const processNomina = function(id) {
    return Vue.http.post('proccess/nomina/' + id, {}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response) {
                throw response.body.error
            }

            return response.body
        })
}

export const CerrarNomina = function(id) {
    return Vue.http.post(`close/nomina/${id}`, {}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const repairNomina = function(id) {
    return Vue.http.post(`repair/nomina/${id}`, {}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const sendNomina = function(id) {
    return Vue.http.post('send/nomina/' + id, {}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response) {
                throw response.body.error
            }

            return response.body
        })
}

export const createInventory = function(sede) {
    return Vue.http.post('create/inventory', {sede: sede}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response) {
                throw response.body.error
            }

            return response.body
        })
}

export const getAnticipos = function(limit, offset) {
    return Vue.http.get(`anticipos?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const createAnticipoByModel = function (info) {
    return Vue.http.patch('create/anticipo/model/', info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const deleteModelAnticipo = function (id) {
    return Vue.http.delete('delete/anticipos/model/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getConsolidadoJugueteria = function(limit, offset, uid) {
    return Vue.http.get(`consolidado/${uid}/jugueteria?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getConsolidadoVariedades = function(limit, offset, uid) {
    return Vue.http.get(`consolidado/${uid}/variedades?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getConsolidadoBonificaciones = function(nid) {
    return Vue.http.get(`consolidado/nomina/${nid}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getLastNomina = function() {
    return Vue.http.get('last/nomina/real/time', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getRealTimeSubnomina = function() {
    return Vue.http.get('real/time/subnomina', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getLastTrm = function() {
    return Vue.http.get('real/time/trm', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const anticipoUpdatePhotoReceptionist = function (image, id) {
    var formData = new FormData()
    formData.append('path', image)

    return Vue.http.post('update/anticipo/picture/' + id + '/store?token=' + store.state.user.access_token, formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }

            return response.body
        })
}

export const getAnticiposReceptionist = function(limit, offset) {
    return Vue.http.get(`anticipos/store?limit=${limit}&offset=${offset}`, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const createAnticipoByModelReceptionist = function (info) {
    return Vue.http.patch('create/anticipo/model/store', info, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const deleteModelAnticipoReceptionist = function (id) {
    return Vue.http.delete('delete/anticipos/model/' + id + '/store', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getAnticiposTypesReceptionist = function() {
    return Vue.http.get('anticipos/type/list/store', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getAnticiposMediosReceptionist = function() {
    return Vue.http.get('anticipos/medios/list/store', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getPeriods = function() {
    return Vue.http.get('periods/habitacion/list', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const addNewPeriod = function(fechaInicial, fechaFinal) {
    return Vue.http.post('create/period', {inicial: fechaInicial, final: fechaFinal}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.error) {
                throw response.body.error
            }

            return response.body
        })
}

export const removePeriod = function (id) {
    return Vue.http.delete('period/' + id, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const getEstadisticas = function() {
    return Vue.http.get('estadisticas/modelos', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export const changePorcentage = function (uid, nomindaId) {
    return Vue.http.post(`change/porcentage/nomina/${nomindaId},`, {uid: uid}, {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.error) {
                throw response.body.error
            }

            return response.body
        })
}

export const getWPSinfo = function() {
    return Vue.http.get('wps/info', {
        headers: {
            'Authorization': store.state.user.access_token
        }})
        .then((response) => {
            if (response.body.errors) {
                return false
            }
            return response.body
        })
}

export default {
    Login: Login,
    Me: Me,
    ModelRegister: ModelRegister,
    profileAdminRegister: profileAdminRegister,
    saveBankInfo: saveBankInfo,
    saveModelPlatform: saveModelPlatform,
    getPlatforms: getPlatforms,
    getProfileInfo: getProfileInfo,
    getBankInfo: getBankInfo,
    updatePlatform: updatePlatform,
    updateBankInfo: updateBankInfo,
    updateProfileInfo: updateProfileInfo,
    updateAdminProfileInfo: updateAdminProfileInfo,
    changeStatus: changeStatus,
    changeStatusAdmin: changeStatusAdmin,
    addNewPlatforms: addNewPlatforms,
    deletePlatform: deletePlatform,
    getApprovedList: getApprovedList,
    getBlockList: getBlockList,
    getNewList: getNewList,
    getPendingList: getPendingList,
    getAllModels: getAllModels,
    createCategory: createCategory,
    getCategories: getCategories,
    deleteCategory: deleteCategory,
    getCategory: getCategory,
    changeName: changeName,
    addProduct: addProduct,
    productUpdatePhoto: productUpdatePhoto,
    getAllProducts: getAllProducts,
    getInfoProducts: getInfoProducts,
    getProductsCategoryList: getProductsCategoryList,
    getProductInfo: getProductInfo,
    getIngresos: getIngresos,
    getSells: getSells,
    getCategoryList: getCategoryList,
    changeProductInfo: changeProductInfo,
    addInventory: addInventory,
    productUpdatePhotoByName: productUpdatePhotoByName,
    deleteInventory: deleteInventory,
    getPendingDocuments: getPendingDocuments,
    getApprovedDocuments: getApprovedDocuments,
    generateDocument: generateDocument,
    getOweStoreByModel: getOweStoreByModel,
    getOweJugueteriaByModel: getOweJugueteriaByModel,
    getOweVariedadesByModel: getOweVariedadesByModel,
    getOweMultasByModel: getOweMultasByModel,
    getMultasListByModel: getMultasListByModel,
    getStoreListByModel: getStoreListByModel,
    getPendingChargesByModel: getPendingChargesByModel,
    getModelStagename: getModelStagename,
    createMultaByModel: createMultaByModel,
    createIngresoByModel: createIngresoByModel,
    deleteModelMulta: deleteModelMulta,
    deleteModelIngreso: deleteModelIngreso,
    getSalaryCertificate: getSalaryCertificate,
    getBankCertificate: getBankCertificate,
    getPendingDocumentsByModel: getPendingDocumentsByModel,
    getPendingProductsToDelete: getPendingProductsToDelete,
    removeProductSolicitud: removeProductSolicitud,
    removeSolicitdPicture: removeSolicitdPicture,
    aprobarPicture: aprobarPicture,
    removeProductLedger: removeProductLedger,
    getNotificationsModel: getNotificationsModel,
    NotificationsTypes: NotificationsTypes,
    createIndividualNotice: createIndividualNotice,
    deleteNotificationByModel: deleteNotificationByModel,
    pauseNotificationByModel: pauseNotificationByModel,
    resetNotificationByModel: resetNotificationByModel,
    changeDateNotificationByModel: changeDateNotificationByModel,
    getNotificationModelList: getNotificationModelList,
    createNotificationGroup: createNotificationGroup,
    getNotifications: getNotifications,
    getModelWithOutNofitication: getModelWithOutNofitication,
    addModelsToNotificacion: addModelsToNotificacion,
    notificationChangeDate: notificationChangeDate,
    pauseNotification: pauseNotification,
    resetNotification: resetNotification,
    deleteNotification: deleteNotification,
    getAllMultasListByModel: getAllMultasListByModel,
    deleteProduct: deleteProduct,
    getInventory: getInventory,
    getPendingProducts: getPendingProducts,
    getApprovedProducts: getApprovedProducts,
    getMultasList: getMultasList,
    getCantMultas: getCantMultas,
    getSumMultas: getSumMultas,
    getCantMultasHoy: getCantMultasHoy,
    getSumMultasHoy: getSumMultasHoy,
    mostFinedModels: mostFinedModels,
    getIngresosList: getIngresosList,
    getCantIngresos: getCantIngresos,
    getSumIngresos: getSumIngresos,
    getCantIngresosHoy: getCantIngresosHoy,
    getSumIngresosHoy: getSumIngresosHoy,
    mostFinedModelsIngresos: mostFinedModelsIngresos,
    getModelsWithStatusNotblock: getModelsWithStatusNotblock,
    getConsumos: getConsumos,
    getBestBuyer: getBestBuyer,
    getBestProducts: getBestProducts,
    getPendings: getPendings,
    getCantConsumos: getCantConsumos,
    getSumConsumos: getSumConsumos,
    getCantConsumosHoy: getCantConsumosHoy,
    getSumConsumosHoy: getSumConsumosHoy,
    getUsersTypes: getUsersTypes,
    getMonitorList: getMonitorList,
    getAdministradorList: getAdministradorList,
    saveMonitor: saveMonitor,
    saveAdmin: saveAdmin,
    getMonitorAndAdmin: getMonitorAndAdmin,
    getLedgersModel: getLedgersModel,
    getPlatformsModel: getPlatformsModel,
    getPositionByModel: getPositionByModel,
    getTotalModelsByPlatform: getTotalModelsByPlatform,
    getTotalDollarsByPlatform: getTotalDollarsByPlatform,
    getPlatformsLedgers: getPlatformsLedgers,
    getModelsPlatformRanking: getModelsPlatformRanking,
    getTotalTokensToday: getTotalTokensToday,
    getDayPlatformRanking: getDayPlatformRanking,
    getPlatformsStudioTotal: getPlatformsStudioTotal,
    getAdminList: getAdminList,
    getPlatformsStudioCant: getPlatformsStudioCant,
    getSedesList: getSedesList,
    getAdminInfo: getAdminInfo,
    changeAdminProfile: changeAdminProfile,
    profileAdminPictureUpdate: profileAdminPictureUpdate,
    changePasswordAdmin: changePasswordAdmin,
    updateProfilePicture: updateProfilePicture,
    getAllModelsSearch: getAllModelsSearch,
    createPendingCharge: createPendingCharge,
    getEgresosTypeList: getEgresosTypeList,
    getIngresosTypeList: getIngresosTypeList,
    addNewEgresoType: addNewEgresoType,
    deleteEgresoType: deleteEgresoType,
    addNewIngresoType: addNewIngresoType,
    deleteIngresoType: deleteIngresoType,
    getAllModelsToSelect: getAllModelsToSelect,
    getAllSolicitudes: getAllSolicitudes,
    getPendingPictures: getPendingPictures,
    getUsersDetect: getUsersDetect,
    deleteUserDetect: deleteUserDetect,
    updateUsersDetects: updateUsersDetects,
    getNominas: getNominas,
    editarNomina: editarNomina,
    changeProductType: changeProductType,
    getAbonoListByModel: getAbonoListByModel,
    getPendingTypes: getPendingTypes,
    getAnticiposTypes: getAnticiposTypes,
    getAnticiposMedios: getAnticiposMedios,
    changeTRM: changeTRM,
    deletePending: deletePending,
    editEgreso: editEgreso,
    editIngreso: editIngreso,
    importProfiles: importProfiles,
    exportProfiles: exportProfiles,
    statusList: statusList,
    getPlatformsNomina: getPlatformsNomina,
    getPendingNomina: getPendingNomina,
    getAnticiposNomina: getAnticiposNomina,
    getEgresosNomina: getEgresosNomina,
    getIngresosNomina: getIngresosNomina,
    getJugueteriaNomina: getJugueteriaNomina,
    getVariedadesNomina: getVariedadesNomina,
    getMecatoNomina: getMecatoNomina,
    getLastLedgersNomina: getLastLedgersNomina,
    addPendingNomina: addPendingNomina,
    addEgresoNomina: addEgresoNomina,
    addAnticipoNomina: addAnticipoNomina,
    addIngresoNomina: addIngresoNomina,
    addVentaNomina: addVentaNomina,
    getPlatformsSubnomina: getPlatformsSubnomina,
    detelePendingNomina: detelePendingNomina,
    deleteEgresoNomina: deleteEgresoNomina,
    deteleAnticipoNomina: deteleAnticipoNomina,
    deleteIngresoNomina: deleteIngresoNomina,
    deleteVentaNomina: deleteVentaNomina,
    addSkyprivateLedgers: addSkyprivateLedgers,
    detectModels: detectModels,
    uploadMultasXML: uploadMultasXML,
    uploadIngresosXML: uploadIngresosXML,
    updateBongaLedgers: updateBongaLedgers,
    createNomina: createNomina,
    processNomina: processNomina,
    CerrarNomina: CerrarNomina,
    repairNomina: repairNomina,
    sendNomina: sendNomina,
    createInventory: createInventory,
    getAnticipos: getAnticipos,
    createAnticipoByModel: createAnticipoByModel,
    deleteModelAnticipo: deleteModelAnticipo,
    getConsolidadoJugueteria: getConsolidadoJugueteria,
    getConsolidadoVariedades: getConsolidadoVariedades,
    getAdminProfileInfo: getAdminProfileInfo,
    getModelsListByAdmin: getModelsListByAdmin,
    getConsolidadoBonificaciones: getConsolidadoBonificaciones,
    getLastNomina: getLastNomina,
    getRealTimeSubnomina: getRealTimeSubnomina,
    getLastTrm: getLastTrm,
    importNominaAdmin: importNominaAdmin,
    getPeriods: getPeriods,
    addNewPeriod: addNewPeriod,
    removePeriod: removePeriod,
    getEstadisticas: getEstadisticas,
    changePorcentage: changePorcentage,
    getHabsBySede: getHabsBySede,
    Store: {
        startStore: startStore,
        getLastStoreStatus: getLastStoreStatus,
        getOpenVentas: getOpenVentas,
        changeCantidadProducto: changeCantidadProducto,
        removeLedgerStore: removeLedgerStore,
        closeVenta: closeVenta,
        getFinalizeVentas: getFinalizeVentas,
        solicitudEliminar: solicitudEliminar,
        removeVenta: removeVenta,
        closeStore: closeStore,
        getAllModelsStore: getAllModelsStore,
        getCategories: getCategoriesStore,
        getProductsListByCategory: getProductsListByCategory,
        generateSellStore: generateSellStore,
        anticipoUpdatePhoto: anticipoUpdatePhotoReceptionist,
        deleteModelAnticipo: deleteModelAnticipoReceptionist,
        createAnticipoByModel: createAnticipoByModelReceptionist,
        getAnticipos: getAnticiposReceptionist,
        getAnticiposTypes: getAnticiposTypesReceptionist,
        getAnticiposMedios: getAnticiposMediosReceptionist
    }
}



// WEBPACK FOOTER //
// ./src/api/index.js